var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnEpubUploadInBottomSheet = function SvgIcnEpubUploadInBottomSheet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_276_129885)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0002 1.19922C14.442 1.19922 14.8002 1.55739 14.8002 1.99922V6.44366C14.8002 6.52617 14.833 6.60531 14.8913 6.66365C14.9497 6.722 15.0288 6.75477 15.1113 6.75477H19.5558C19.9976 6.75477 20.3558 7.11295 20.3558 7.55477C20.3558 7.9966 19.9976 8.35477 19.5558 8.35477H15.1113C14.6044 8.35477 14.1183 8.15342 13.7599 7.79502C13.4015 7.43662 13.2002 6.95052 13.2002 6.44366V1.99922C13.2002 1.55739 13.5584 1.19922 14.0002 1.19922Z",
    fill: "#57595E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28591 2.79922C5.88472 2.79922 5.50433 2.95438 5.22733 3.22369C4.95109 3.49226 4.8002 3.85163 4.8002 4.22144V19.777C4.8002 20.1468 4.95109 20.5062 5.22733 20.7747C5.50433 21.0441 5.88472 21.1992 6.28591 21.1992H17.7145C18.1157 21.1992 18.4961 21.0441 18.7731 20.7747C19.0493 20.5062 19.2002 20.1468 19.2002 19.777V7.89277L13.9611 2.79922H6.28591ZM4.112 2.0765C4.69231 1.51231 5.47469 1.19922 6.28591 1.19922H14.2859C14.4942 1.19922 14.6942 1.28044 14.8436 1.42562L20.5579 6.98118C20.7128 7.1318 20.8002 7.33869 20.8002 7.55477V19.777C20.8002 20.5859 20.4695 21.357 19.8884 21.9219C19.3081 22.4861 18.5257 22.7992 17.7145 22.7992H6.28591C5.47468 22.7992 4.69231 22.4861 4.112 21.9219C3.53093 21.357 3.2002 20.5859 3.2002 19.777V4.22144C3.2002 3.41251 3.53093 2.64142 4.112 2.0765Z",
    fill: "#57595E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 9.19922C12.442 9.19922 12.8002 9.55739 12.8002 9.99922V15.9992C12.8002 16.441 12.442 16.7992 12.0002 16.7992C11.5584 16.7992 11.2002 16.441 11.2002 15.9992V9.99922C11.2002 9.55739 11.5584 9.19922 12.0002 9.19922Z",
    fill: "#57595E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4345 9.43353C11.7469 9.12111 12.2535 9.12111 12.5659 9.43353L15.0659 11.9335C15.3783 12.246 15.3783 12.7525 15.0659 13.0649C14.7535 13.3773 14.2469 13.3773 13.9345 13.0649L12.0002 11.1306L10.0659 13.0649C9.75346 13.3773 9.24693 13.3773 8.93451 13.0649C8.62209 12.7525 8.62209 12.246 8.93451 11.9335L11.4345 9.43353Z",
    fill: "#57595E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_129885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnEpubUploadInBottomSheet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_epub_upload_in_bottom_sheet.9252bbcc.svg";
export { ForwardRef as ReactComponent };